/* eslint-disable @typescript-eslint/ban-types */
export const getIsFunction = (value: unknown): value is Function =>
  /* eslint-enable @typescript-eslint/ban-types */
  typeof value === 'function';
